import { useState, useEffect } from "react";
import "./Billing.css";
import { loadEnvConfig } from "../../environments/base";
import StripePricingTable from "./StripePricingTable";
import { useAccount } from "../../hooks/useAccount";
import { AccountInfo } from "winslow-core";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData";
import { selectAccountInfo } from "../../redux/features/account/accountSlice";
import { formatDate3 } from "winslow-core";
import Modal from "../shared/Modal";

const billingPortalUrl = loadEnvConfig("REACT_APP_STRIPE_CUSTOMER_PORTAL");

const Billing = () => {
  const acct = useAccount();
  const storeUser = useSelector(selectUser);
  const accountInfo = useSelector(selectAccountInfo);
  const [manageSubscriptionInfoOpen, setManageSubscriptionInfoOpen] =
    useState<boolean>(false);
  useEffect(() => {
    // reload the account info every time this page is loaded
    if (storeUser) {
      (async () => {
        acct.loadAccountInfo(storeUser.id);
      })();
    }
  }, []);

  const handleManageSubscriptionClick = () => {
    window.open(billingPortalUrl, "_blank");
  };

  const determineIntervalText = (interval: "month" | "year" | null) => {
    if (interval === "month") {
      return "monthly";
    }

    if (interval === "year") {
      return "yearly";
    }

    return "";
  };

  console.log("[Billing] accountInfo: ", accountInfo);

  return (
    <div id="billing">
      <div className="page-title" style={{ marginBottom: "0px" }}>
        Upgrade and Billing
      </div>

      {accountInfo && !accountInfo.stripeSubscriptionStatus && (
        <>
          {accountInfo.questionsCount >= accountInfo.questionsLimit ? (
            <div className="billing-stats">
              You have reached your question limit.
            </div>
          ) : (
            <div className="billing-stats">
              You have used {accountInfo.questionsCount} of{" "}
              {accountInfo.questionsLimit} questions in your free account.
            </div>
          )}

          <div className="billing-pricing">
            <StripePricingTable />
          </div>
        </>
      )}

      {accountInfo &&
        accountInfo.stripeSubscriptionStatus &&
        accountInfo.stripeSubscriptionPeriodEnd && (
          <div className="billing-subscription-info">
            <div className="billing-details">
              You are on the{" "}
              {determineIntervalText(
                accountInfo?.stripeSubscriptionInterval as
                  | "month"
                  | "year"
                  | null
              )}{" "}
              plan. Your subscription expires on{" "}
              {formatDate3(new Date(accountInfo.stripeSubscriptionPeriodEnd))}.
            </div>
            <div className="billing-manage">
              <button
                className="billing-button"
                onClick={() => setManageSubscriptionInfoOpen(true)}>
                Manage Subscription
              </button>
            </div>
          </div>
        )}

      <Modal
        style={null}
        isOpen={manageSubscriptionInfoOpen}
        onClose={() => setManageSubscriptionInfoOpen(false)}
        canClose={false}
        allowClickout={true}>
        <>
          <div id="modal-manage-subscription-info">
            <div className="modal-manage-subscription-info-title">
              Please Note
            </div>

            <div className="modal-manage-subscription-info-content">
              You will need to login to Stripe with the same email you used to
              create your subscription.
            </div>

            <div className="modal-manage-subscription-info-footer">
              <div className="modal-manage-subscription-info-buttons">
                <button
                  onClick={() => setManageSubscriptionInfoOpen(false)}
                  className="collections-button-negative">
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setManageSubscriptionInfoOpen(false);
                    handleManageSubscriptionClick();
                  }}
                  className="collections-button">
                  Continue
                </button>
              </div>
            </div>
          </div>
        </>
      </Modal>
    </div>
  );
};

export default Billing;
